import { booking } from '@assets/icons'
import Table from '@components/table'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { Offer } from '@apis'

const Offers = ({ user }: { user?: any }) => {
  const {
    items: offers,
    loading,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.offers)
  const [page, setPage] = useState<number>(1)

  const fetchOffers = async () => {
    await Offer.list({
      state: 'offers',
      params: { limit: 20, page, createdBy: user?.id },
    })
  }
  const columns = [
    { title: 'Offer Title', key: 'offerTitle', render: (item) => item.title },
    { title: 'Promo Code', key: 'promoCode', render: (item) => item.code },
    {
      title: 'Discount Amount',
      key: 'discountAmount',
      render: (item) => item.discountAmount,
    },
    { title: 'Times Used', key: 'timesUsed' },
    {
      title: 'Offer Validity',
      key: 'offerValidity',
      render: (item) => item.validDate,
    },
    { title: 'Total Offered', key: 'totalOffered' },
  ]
  useEffect(() => {
    fetchOffers()
  }, [])
  return (
    <Table
      text="Offers Provided"
      icon={booking}
      columns={columns}
      totalItems={totalItems}
      totalPages={totalPages}
      loading={loading}
      data={offers}
      pageControlled={page}
      onPageChange={setPage}
    />
  )
}

export default Offers
